'use strict'

import GoogleMapsApi from 'load-google-maps-api'
import gmapStyles from '../json/gmapStyles'

let self

export default self = {
  container : document.getElementById('map'),
  markerIcon : '/app/themes/jasonhutchison/assets/img/marker.svg',

  mapArgs : {
    zoom: 14,
    styles: gmapStyles,
    disableDefaultUI: true,
    zoomControl: true,
    center: { // Default center is "Vancouver"
      lat : 49.2827291,
      lng : -123.12073750000002
    }
  },

  api : () => GoogleMapsApi({ key : 'AIzaSyBySenLusv5xiI63iEn30r64cCZlXVJnUs' }),

  getLatLngFromAddress : (api, address, city) => {
    const Geocoder = new api.Geocoder()

    return new Promise( (resolve, reject) => Geocoder.geocode({'address' : `${address} ${city}`}, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        console.info("[getLatLngFromAddress] Geocoding Successful", results);
        for (var i = 0; i < results.length; i++) {
	        if (results[i].geometry.location.location_type == 'ROOFTOP') {

		        resolve({
		          lat : results[i].geometry.location.lat(),
		          lng : results[i].geometry.location.lng()
		        })
	        }
        }

        resolve({
          lat : results[0].geometry.location.lat(),
          lng : results[0].geometry.location.lng()
        })
      } else {
        console.error("[getLatLngFromAddress] Geocoding Error");

        reject({
          results : results,
          status : status
        })
      }
    }))
  }

}
